import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[doubleDecimalNumbersOnly]'
})
export class DoubleDecimalNumbersOnlyDirective {

  constructor(private _el: ElementRef, private control: NgControl) { }
  
  numberRegexValidator: RegExp = /^\d+(\,\d{0,2})?$/;

  @HostListener('input', ['$event']) onInputChange() {
    const currentValue = this._el.nativeElement.value;

    if (this.numberRegexValidator.test(currentValue)) {
      this._el.nativeElement.value = currentValue;
      this.control.control?.setValue(this._el.nativeElement.value);
      return
    }
    this._el.nativeElement.value = currentValue.slice(0, -1);
    this.control.control?.setValue(this._el.nativeElement.value);
    return;
  }

}
